import{ useState } from "react";
import { Search} from "lucide-react";


export default function HeadFilter() {
  const [searchTerm] = useState("")

  return (
    <div className="d-flex flex-wrap gap-3 mb-3">
      {/* Search Input */}
      <div style={{ position: "relative", flex: 1, minWidth: "200px", margin:'0rem 20rem 0rem 20rem ' }}>
        <Search size={14} style={{
          position: "absolute",
          left: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none"
        }} />
        <input className="w-100 px-3 ps-4 py-2 border rounded-2 small"

          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          
        />
      </div>
    </div>
  );
}